import {
  TOKENHOLDERS_STATES,
  DISTRIBUTION_STATES,
} from "./TokenHolders.constants";

const initialState = {
  status: TOKENHOLDERS_STATES.idle,
  distributionStatus: DISTRIBUTION_STATES.idle,
  token: null,
  data: [],
  distribution: null,
  start: 0,
  limit: 10,
  total: 0,
  rangeTotal: 0,
  error: null,
  distributionError: null,
};

const TokenHolders = (
  state = initialState,
  action: {
    type: string;
    distribution: any;
    data: [];
    token: string;
    start: number;
    limit: number;
    total: number;
    rangeTotal: number;
    error: any;
  }
) => {
  switch (action.type) {
    case "GET_TOKENHOLDERS":
      return {
        ...state,
        status: TOKENHOLDERS_STATES.loading,
        token: action.token,
        start: action.start,
        limit: action.limit,
        data: [],
        error: null,
      };
    case "GET_TOKENHOLDERS_SUCCESS":
      return {
        ...state,
        status: TOKENHOLDERS_STATES.success,
        data: action.data,
        total: action.total,
        rangeTotal: action.rangeTotal,
        error: null,
      };
    case "GET_TOKENHOLDERS_FAILURE":
      return {
        ...state,
        status: TOKENHOLDERS_STATES.failure,
        data: [],
        total: 0,
        rangeTotal: 0,
        error: action.error,
      };
    case "GET_DISTRIBUTION":
      return {
        ...state,
        distributionStatus: DISTRIBUTION_STATES.loading,
        token: action.token,
        distribution: null,
        distributionError: null,
      };
    case "GET_DISTRIBUTION_SUCCESS":
      return {
        ...state,
        distributionStatus: DISTRIBUTION_STATES.success,
        distribution: action.distribution,
        distributionError: null,
      };
    case "GET_DISTRIBUTION_FAILURE":
      return {
        ...state,
        distributionStatus: DISTRIBUTION_STATES.failure,
        distribution: null,
        distributionError: action.error,
      };
    default:
      return state;
  }
};

export default TokenHolders;
